<template>
  <div>
    <el-row class="m-b15">
      <el-col :span="12">
        <el-input size="medium" v-model="keyword" placeholder="发票编号、买家机构名称"></el-input>
      </el-col>
      <el-col :span="6">
        <el-button size="medium" type="primary" @click="loadData">查询</el-button>
        <el-button size="medium" type="primary" @click="reset">重置</el-button>
      </el-col>
    </el-row>
    <el-table :data="dataList">
      <el-table-column label="发票号码" prop="invoiceNumber" align="center"></el-table-column>
      <el-table-column label="开票日期" prop="invoiceDate" align="center" width="100">
        <template v-slot="{ row }">
          <div>{{ row.invoiceDate | formatTime('{y}-{M}-{d}') }}</div>
        </template>
      </el-table-column>
      <el-table-column label="商家抬头" prop="sellerOrgName" align="center"></el-table-column>
      <el-table-column label="买方抬头" prop="buyerOrgName" align="center"></el-table-column>
      <el-table-column label="申请单单号" prop="invoiceApplyCode" align="center" width="250">
        <template v-slot="{ row }">
          <el-button type="text" @click="viewDetail(row.invoiceApplyId)">{{
            row.invoiceApplyCode
          }}</el-button>
        </template>
      </el-table-column>
      <el-table-column label="快递单号" prop="expressTrackingNum" align="center"></el-table-column>
      <el-table-column label="快递公司" prop="expressCompany" align="center"></el-table-column>
      <el-table-column label="状态" prop="status" align="center" width="70">
        <template v-slot="{ row }">
          <div>{{ row.status | convertInvoiceStatus }}</div>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      background
      class="page"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="pageNum"
      :page-size="pageSize"
      :total="totalNum"
      layout="total, sizes, prev, pager, next, jumper"
    >
    </el-pagination>
  </div>
</template>

<script>
export default {
  name: 'abandon-list',
  filters: {
    convertInvoiceStatus(status) {
      let statuses = {
        '1': '正常',
        '2': '已废弃'
      }
      return statuses[status] ? statuses[status] : ''
    }
  },
  data() {
    return {
      dataList: [],
      total: 0,
      pageSize: 10,
      pageNum: 1,
      totalNum: 0,
      keyword: ''
    }
  },
  created() {
    this.loadData()
  },
  methods: {
    async loadData() {
      let params = {
        pageSize: this.pageSize,
        pageNum: this.pageNum,
        status: 2 // 本页全部为已经废弃的发票
      }

      if (this.keyword) {
        params.invoiceNumberOrBuyerOrgName = this.keyword
      }

      let { success, data } = await this.$post('invoice.seller.queryInvoiceInfo', {
        request: params
      })
      if (success) {
        let { totalNum: total, invoiceInfoVOS: dataList } = data[0]
        this.totalNum = total
        this.dataList = dataList
      }
    },
    handleSizeChange(size) {
      this.pageSize = size
      this.loadData()
    },
    handleCurrentChange(num) {
      this.pageNum = num
      this.loadData()
    },
    viewDetail(id) {
      this.$router.push({ path: '/invoice/invoice-detail/' + id })
    },
    reset() {
      this.keyword = ''
      this.pageNum = 1
      this.loadData()
    }
  }
}
</script>

<style lang="scss" scoped>
.page {
  text-align: right;
  margin-top: 20px;
}
</style>
